<template>
  <div class="analysis_warp">
    <div class="top">
      <img src="@/static/topCard/CaretCircleLeft.png"
           @click="back"
           alt="">

    </div>

    <div class="content">
      <div class="content_top">
        你的专属学科检测报告已生成
      </div>
      <div class="content_top1">
        <span>打开微信扫一扫二维码<span style="color:#2196f3">添加客服好友获取</span></span>
      </div>

      <div class="content_middle">
        <img src="@/static/quick1.png"
             alt="">

      </div>
      <div style="display: flex;justify-content: center;">
      <div class="content_bottom"
           >
        专属学科检测报告 + 薄弱考点分析
      </div>
       </div>
    </div>
 
  </div>

</template>

 
<script setup>

import { getUserSubject } from '@/api/subject.js'
import { addPost } from '@/api/post.js'
import { nextTick, onMounted, ref, reactive, onUnmounted } from 'vue'
import { getSkbSubject } from '@/api/quick.js'

import { message } from 'ant-design-vue'
import { useRoute, useRouter } from "vue-router";

const router = useRouter()


let route = useRoute()
let showWindow = ref(false)
let mapRef = ref()
let subject_id = ref('')
let userinfo = ref(null)
let ScoreRef = ref(null)
let userId = ref('')
let subjectIndex = ref(0)
let subjectList = ref([])
let activeIndex = ref(null)
let paper_duration = ref(0)
onMounted(() => {
  // getSubject()
  userinfo.value = JSON.parse(window.localStorage.getItem('userInfo'))
  userId.value = Number(userinfo.value.user_id)
  nextTick(() => {

  })
  
})
 
 
const back = () => {
  router.push('/quickPaper')
  // debugger
}
onUnmounted(() => {
  
})

 


</script>
 
<style lang="scss" scoped>
.analysis_warp {
  width: 100vw;
  height: 100vh;
  overflow: hidden;
  background: #f6f6f6;

  .top {
    width: 1856rem;
    margin-top: 40rem;

    align-items: center;
    gap: 10rem;
    margin-left: 32rem;
    display: flex;
    border-radius: 32rem;
    background: #fff;
    height: 80rem;
    padding: 0 24rem;
    // justify-content: center;
    color: var(--light-333333, #333);
    text-align: center;

    font-size: 28rem;
    font-style: normal;
    font-weight: 600;
    line-height: 42rem; /* 150% */
  }
  .middle {
    img {
      width: 14rem;
      height: 14rem;
    }
    display: flex;
    width: 1200rem;
    margin-left: 360rem;
    height: 40rem;
    flex-shrink: 0;
    border-radius: 5rem;
    background: var(--Brand-Color_1, #e3f2fd);
    color: #000;
    text-align: center;
    align-items: center;
    font-size: 16rem;
    font-style: normal;
    font-weight: 400;
    line-height: 24rem; /* 150% */
    margin-top: 32rem;
    margin-bottom: 32rem;
  }

  .content {
    margin-left: 360rem;
    width: 1200rem;
    height: 712rem;
    border-radius: 32rem;
margin-top: 40rem;
    border: 1rem solid var(--light-eeeeee, #eee);
    background: linear-gradient(180deg, #f1f4ff 0%, #fff 100%);
    .content_bottom {
      border-radius: 100rem;
      background: var(--2196-f-3, #2196f3);
      display: flex;
      width: 444rem;
      height: 60rem;
      padding: 0 12rem;
      justify-content: center;
      align-items: center;
      gap: 8rem;
      flex-shrink: 0;
      color: #FFF;
text-align: center;
 
font-size: 24rem;
font-style: normal;
font-weight: 600;
line-height: 36rem; /* 150% */
    }
    .content_middle {
      display: flex;
      justify-content: center;
      padding-top: 32rem;
      padding-bottom: 32rem;
      grid-template: repeat(3, 1fr) / repeat(3, 1fr);
      .active {
        color: #fff !important;
        background: var(--Brand-Color_6default, #2196f3) !important;
      }
      .item {
        color: var(--Brand-Color_6default, #2196f3);
        display: flex;
        width: 112rem;
        height: 40rem;
        padding: 6rem 20rem;
        justify-content: center;
        align-items: center;
        gap: 2rem;
        flex-shrink: 0;
        // grid-row: 1 / span 1;
        // grid-column: 1 / span 1;
        border-radius: var(--Radius-XS, 8rem);
        border: 1rem solid var(--2196-f-3, #2196f3);
        background: var(--light-ffffff, #fff);
      }
    }
    .content_top1 {
      display: flex;

      // height: 72rem;
      padding-top: 24rem;

      flex-direction: column;
      align-items: center;
      gap: 40rem;
      flex-shrink: 0;
      overflow: hidden;
      color: var(--light-333333, #333);
      text-align: center;
      text-overflow: ellipsis;

      font-size: 24rem;
      font-style: normal;
      // font-weight: 600;
      line-height: 36rem; /* 150% */
    }
    .content_top {
      display: flex;

      // height: 72rem;
      padding-top: 80rem;

      flex-direction: column;
      align-items: center;
      gap: 40rem;
      flex-shrink: 0;
      overflow: hidden;
      color: var(--light-333333, #333);
      text-align: center;
      text-overflow: ellipsis;

      font-size: 28rem;
      font-style: normal;
      font-weight: 600;
      line-height: 36rem; /* 150% */
    }
  }
}
.fixed_btn {
  position: fixed;
  top: 50rem;
  right: 30rem;
  font-size: 24rem;
  display: flex;
  // width: 350rem;
  div {
    // flex: 1;
    text-align: center;
  }
  img {
    width: 36rem;
    height: 36rem;
    margin-left: 30rem;
  }
}
</style>